module.exports = __webpack_public_path__ + "static/media/friends-of-tmc-img-mob.7aa0b5cd.png";